export enum TipoMuroEnum {
  Rebocado = 'Rebocado',
  Frisado = 'Frisado',
  SemMuro = 'Sem Muro'
}
